export default __webpack_public_path__ + "static/media/logo-darkMode.b0ca27fe.svg";